(function() {
  function normalizeRule(rule) {
    let normalizedRule = rule;

    if (typeof normalizedRule === 'string') {
      try {
        normalizedRule = JSON.parse(normalizedRule);
      } catch (error) {
        return null;
      }
    }

    if (typeof normalizedRule === 'string') {
      try {
        normalizedRule = JSON.parse(normalizedRule);
      } catch (error) {
        return null;
      }
    }

    if (!normalizedRule || typeof normalizedRule !== 'object' || normalizedRule.active !== true || !normalizedRule.rule_type) {
      return null;
    }

    return normalizedRule;
  }

  function expandItems(items) {
    const expanded = [];

    items.forEach((item) => {
      const quantity = Math.max(0, Number(item.quantity) || 0);
      for (let i = 0; i < quantity; i += 1) {
        expanded.push({
          price: Number(item.price) || 0,
          rule: normalizeRule(item.discountRule),
          productId: item.productId,
          id: item.id,
        });
      }
    });

    return expanded;
  }

  function groupKeyForItem(item) {
    const rule = normalizeRule(item.rule);
    if (!rule?.group) return null;
    return `${rule.rule_type}::${rule.group}`;
  }

  function cheapestItemsDiscount(items, freeItemCount) {
    if (freeItemCount <= 0) return 0;

    return [...items]
      .sort((a, b) => a.price - b.price)
      .slice(0, freeItemCount)
      .reduce((sum, item) => sum + item.price, 0);
  }

  function fixedPriceDiscount(items, quantityRequired, fixedPrice) {
    if (quantityRequired <= 0) return 0;

    const setCount = Math.floor(items.length / quantityRequired);
    if (setCount <= 0) return 0;

    const fixedPriceCents = Math.round(Number(fixedPrice || 0) * 100);
    const sorted = [...items].sort((a, b) => b.price - a.price);

    let discount = 0;
    for (let setIndex = 0; setIndex < setCount; setIndex += 1) {
      const setItems = sorted.slice(setIndex * quantityRequired, (setIndex + 1) * quantityRequired);
      const setSubtotal = setItems.reduce((sum, item) => sum + item.price, 0);
      discount += Math.max(0, setSubtotal - fixedPriceCents);
    }

    return discount;
  }

  function calculateDiscountForGroup(items) {
    if (!items.length) return 0;

    const rule = normalizeRule(items[0].rule);
    if (!rule) return 0;

    switch (rule.rule_type) {
      case 'buy_x_get_cheapest_free': {
        const quantityRequired = Number(rule.quantity_required) || 0;
        const freeItemCount = quantityRequired > 0 ? Math.floor(items.length / quantityRequired) : 0;
        return cheapestItemsDiscount(items, freeItemCount);
      }

      case 'buy_x_pay_for_x': {
        const quantityRequired = Number(rule.quantity_required) || 0;
        const quantityPaid = Number(rule.quantity_paid) || 0;
        const freePerSet = Math.max(0, quantityRequired - quantityPaid);
        const freeItemCount = quantityRequired > 0 ? Math.floor(items.length / quantityRequired) * freePerSet : 0;
        return cheapestItemsDiscount(items, freeItemCount);
      }

      case 'buy_x_for_rx': {
        const quantityRequired = Number(rule.quantity_required) || 0;
        return fixedPriceDiscount(items, quantityRequired, rule.fixed_price);
      }

      case 'x_amount_off': {
        const amountOff = Math.round(Number(rule.amount_off || 0) * 100);
        return amountOff > 0 ? amountOff * items.length : 0;
      }

      default:
        return 0;
    }
  }

  function calculateBundlePricing(selectedItems) {
    const expanded = expandItems(selectedItems);
    const subtotal = expanded.reduce((sum, item) => sum + item.price, 0);
    const groupedItems = new Map();

    expanded.forEach((item) => {
      const key = groupKeyForItem(item);
      if (!key) return;

      if (!groupedItems.has(key)) {
        groupedItems.set(key, []);
      }

      groupedItems.get(key).push(item);
    });

    let discount = 0;
    groupedItems.forEach((items) => {
      discount += calculateDiscountForGroup(items);
    });

    return {
      subtotal,
      discount,
      total: Math.max(0, subtotal - discount),
    };
  }

  window.AskMarioBundlePricing = {
    calculateBundlePricing,
  };
})();
